<template>
    <v-row>
        <v-col cols="12" style="padding-right: 4px">
            <v-card class="d-flex flex-column" outlined>
                <v-card-title style="border-bottom: 1px solid #404040">
                    <div
                        style="display: flex; align-items: center; width: 100%"
                    >
                        <div
                            class="text-left"
                            style="
                                margin-left: 0;
                                font-size: 13px;
                                font-weight: normal;
                                flex: 1;
                            "
                        >
                            {{ $t("alertHub.alertInfoTitle") }}
                        </div>
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                transform: scale(0.9);
                                transform-origin: right center;
                            "
                        >
                            <v-btn @click="showSoundSettingsDialog = true" icon>
                                <v-icon color="orange"
                                    >mdi-bullhorn-variant</v-icon
                                >
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>

                <v-divider></v-divider>

                <ComponentAlertInfo
                    :serverOptions="serverOptions"
                    :triggered="triggered"
                    :onCommentChanged="onCommentChanged"
                    :resetTrigger="resetTrigger"
                    :profileDetail="profileDetail['mute']"
                />
            </v-card>
            <v-card
                class="d-flex flex-column"
                style="margin-top: 10px"
                outlined
            >
                <v-card-title style="border-bottom: 1px solid #404040">
                    <div
                        style="display: flex; align-items: center; width: 100%"
                    >
                        <div
                            class="text-left"
                            style="
                                margin-left: 0;
                                font-size: 13px;
                                font-weight: normal;
                                flex: 1;
                            "
                        >
                            {{ $t("alertHub.alertHistoryTitle") }}
                        </div>
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                transform: scale(0.9);
                                transform-origin: right center;
                            "
                        >
                            <v-btn @click="refresh = !refresh" icon>
                                <v-icon color="primary">mdi-refresh</v-icon>
                            </v-btn>
                            <v-select
                                v-model="selectedStatus"
                                :items="statusOptions"
                                dense
                                hide-details
                                outlined
                                style="width: 140px; font-size: 12px"
                            ></v-select>
                            <v-menu
                                v-model="datepickerMenu"
                                :close-on-content-click="false"
                                offset-y
                                left
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="historyDate"
                                        dense
                                        hide-details
                                        outlined
                                        readonly
                                        append-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        style="width: 140px; font-size: 12px"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="historyDate"
                                    no-title
                                    @input="datepickerMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                    </div>
                </v-card-title>

                <v-divider></v-divider>

                <ComponentAlertHistory
                    :serverOptions="serverOptions"
                    :triggered="triggered"
                    :onCommentChanged="onCommentChanged"
                    :resetTrigger="resetTrigger"
                    :selectedDate="historyDate"
                    :selectedStatus="selectedStatus"
                    :refresh="refresh"
                />
            </v-card>
        </v-col>
        <v-dialog
            :hide-overlay="true"
            :persistent="true"
            v-model="showSoundSettingsDialog"
            width="600"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        Alert Sound Settings
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="white"
                        icon
                        @click="showSoundSettingsDialog = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-text style="padding-top: 14px">
                    <v-row>
                        <v-col cols="6" class="pb-1 pt-1">
                            <strong>Alert Type</strong>
                        </v-col>
                        <v-col
                            cols="3"
                            class="pb-1 pt-1"
                            style="text-align: center"
                        >
                            <strong>L1</strong>
                        </v-col>
                        <v-col
                            cols="3"
                            class="pb-1 pt-1"
                            style="text-align: center"
                        >
                            <strong>L2</strong>
                        </v-col>
                        <template v-for="type in Object.keys(nameMap)">
                            <v-col cols="6" class="pb-1 pt-1">
                                {{ nameMap[type] }}
                            </v-col>
                            <v-col
                                cols="3"
                                class="pb-1 pt-1"
                                style="text-align: center"
                            >
                                <v-btn
                                    :color="
                                        profileDetail['mute'] &&
                                        profileDetail['mute']['l1'].includes(
                                            type
                                        )
                                            ? 'error'
                                            : 'primary'
                                    "
                                    icon
                                    small
                                    @click="changeSoundSettings(type, 'l1')"
                                    ><v-icon>{{
                                        profileDetail["mute"] &&
                                        profileDetail["mute"]["l1"].includes(
                                            type
                                        )
                                            ? "mdi-volume-off"
                                            : "mdi-volume-high"
                                    }}</v-icon></v-btn
                                >
                            </v-col>
                            <v-col
                                cols="3"
                                class="pb-1 pt-1"
                                style="text-align: center"
                            >
                                <v-btn
                                    :color="
                                        profileDetail['mute'] &&
                                        profileDetail['mute']['l2'].includes(
                                            type
                                        )
                                            ? 'error'
                                            : 'primary'
                                    "
                                    icon
                                    small
                                    @click="changeSoundSettings(type, 'l2')"
                                    ><v-icon>{{
                                        profileDetail["mute"] &&
                                        profileDetail["mute"]["l2"].includes(
                                            type
                                        )
                                            ? "mdi-volume-off"
                                            : "mdi-volume-high"
                                    }}</v-icon></v-btn
                                >
                            </v-col>
                        </template>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click.stop="() => updateSoundSettings()"
                        :loading="loading"
                        >{{ $t("common.form.confirm") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import ComponentAlertInfo from "./ComponentAlertInfo";
import ComponentAlertHistory from "./AlertHistory";
import { mapActions } from "vuex";
import { getServer } from "@services/server";
import common from "@assets/js/common";
import {
    getPageProfile,
    postPageProfile,
    putPageProfile,
} from "@services/page-profile";
import deepClone from "deep-clone";

export default {
    components: {
        ComponentAlertInfo,
        ComponentAlertHistory,
    },
    data() {
        return {
            triggered: false,
            serverOptions: [],
            datepickerMenu: false,
            historyDate: common.getMT4TimeString().split(" ")[0],
            selectedStatus: "OFFBOARD",
            statusOptions: [
                { text: "All", value: null },
                { text: "Processed", value: "OFFBOARD" },
                { text: "Unprocessed", value: "ONBOARD" },
            ],
            refresh: false,
            loading: false,
            showSoundSettingsDialog: false,
            nameMap: {
                MSG_TYPE_MONITOR_FAST_CLOSED_TRADE: "Fast Close",
                MSG_TYPE_MONITOR_HIGH_VOLUME_USD: "High Volume USD",
                MSG_TYPE_MONITOR_HIGH_TRADE_COUNT: "High Trades",
                MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL: "Large PNL",
                MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE:
                    "Low Liquidity Arbitrage",
            },
            profileId: null,
            profileDetail: {},
            defaultProfile: {
                mute: {
                    l1: [],
                    l2: [],
                },
            },
        };
    },
    methods: {
        ...mapActions("AlertHub", ["getRHUsersAction"]),
        onCommentChanged() {
            this.triggered = true;
        },
        resetTrigger() {
            this.triggered = false;
        },
        changeSoundSettings(type, level) {
            const muteList = this.profileDetail["mute"][level];
            if (muteList.includes(type)) {
                muteList.splice(muteList.indexOf(type), 1);
            } else {
                muteList.push(type);
            }
        },
        getProfile() {
            this.loading = true;
            getPageProfile({ meta_value: "alert-hub" })
                .then(({ data }) => {
                    if (data.length) {
                        const profile = data[0];
                        this.profileId = profile["id"];
                        this.profileDetail = JSON.parse(profile["value"]);
                    } else {
                        this.profileId = undefined;
                        this.profileDetail = deepClone(this.defaultProfile);
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.triggered = true;
                });
        },
        updateSoundSettings() {
            this.loading = true;

            if (this.profileId) {
                const params = {
                    id: this.profileId,
                    profile_name: "default",
                    value: this.profileDetail,
                };

                putPageProfile(params).then(() => {
                    this.showSoundSettingsDialog = false;
                    this.getProfile();
                });
            } else {
                const params = {
                    meta_value: "alert-hub",
                    profile_name: "default",
                    value: this.profileDetail,
                };

                postPageProfile(params).then(() => {
                    this.showSoundSettingsDialog = false;
                    this.getProfile();
                });
            }
        },
    },
    mounted() {
        this.getRHUsersAction();
        getServer().then((res) => {
            this.serverOptions = res.data;
            this.getProfile();
        });
    },
    destroyed() {},
};
</script>
